import React, {createContext} from "react";

const viewContext  = createContext(null);

export default function getViewContext()
{
    return viewContext;
}
